import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import Vue from 'vue';
import QField from "../field/QField.js";
import { FormFieldMixin } from "../../mixins/form.js";
import { FileValueMixin } from "../../mixins/file.js";
import MaskMixin from "../../mixins/mask.js";
import CompositionMixin from "../../mixins/composition.js";
import ListenersMixin from "../../mixins/listeners.js";
import { stop } from "../../utils/event.js";
import { addFocusFn } from "../../utils/focus-manager.js";
export default Vue.extend({
  name: 'QInput',
  mixins: [QField, MaskMixin, CompositionMixin, FormFieldMixin, FileValueMixin, ListenersMixin],
  props: {
    value: {
      required: false
    },
    shadowText: String,
    type: {
      type: String,
      default: 'text'
    },
    debounce: [String, Number],
    autogrow: Boolean,
    // makes a textarea
    inputClass: [Array, String, Object],
    inputStyle: [Array, String, Object]
  },
  watch: {
    value: function value(v) {
      if (this.hasMask === true) {
        if (this.stopValueWatcher === true) {
          this.stopValueWatcher = false;
          return;
        }

        this.__updateMaskValue(v);
      } else if (this.innerValue !== v) {
        this.innerValue = v;

        if (this.type === 'number' && this.hasOwnProperty('tempValue') === true) {
          if (this.typedNumber === true) {
            this.typedNumber = false;
          } else {
            delete this.tempValue;
          }
        }
      } // textarea only


      this.autogrow === true && this.$nextTick(this.__adjustHeight);
    },
    autogrow: function autogrow(_autogrow) {
      // textarea only
      if (_autogrow === true) {
        this.$nextTick(this.__adjustHeight);
      } // if it has a number of rows set respect it
      else if (this.qAttrs.rows > 0 && this.$refs.input !== void 0) {
        var inp = this.$refs.input;
        inp.style.height = 'auto';
      }
    },
    dense: function dense() {
      this.autogrow === true && this.$nextTick(this.__adjustHeight);
    }
  },
  data: function data() {
    return {
      innerValue: this.__getInitialMaskedValue()
    };
  },
  computed: {
    isTextarea: function isTextarea() {
      return this.type === 'textarea' || this.autogrow === true;
    },
    isTypeText: function isTypeText() {
      return this.isTextarea === true || ['text', 'search', 'url', 'tel', 'password'].includes(this.type);
    },
    fieldClass: function fieldClass() {
      return "q-".concat(this.isTextarea === true ? 'textarea' : 'input') + (this.autogrow === true ? ' q-textarea--autogrow' : '');
    },
    hasShadow: function hasShadow() {
      return this.type !== 'file' && typeof this.shadowText === 'string' && this.shadowText.length > 0;
    },
    onEvents: function onEvents() {
      var on = _objectSpread(_objectSpread({}, this.qListeners), {}, {
        input: this.__onInput,
        paste: this.__onPaste,
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        change: this.__onChange,
        blur: this.__onFinishEditing,
        focus: stop
      });

      on.compositionstart = on.compositionupdate = on.compositionend = this.__onComposition;

      if (this.hasMask === true) {
        on.keydown = this.__onMaskedKeydown;
      }

      if (this.autogrow === true) {
        on.animationend = this.__adjustHeight;
      }

      return on;
    },
    inputAttrs: function inputAttrs() {
      var attrs = _objectSpread(_objectSpread({
        tabindex: 0,
        'data-autofocus': this.autofocus,
        rows: this.type === 'textarea' ? 6 : void 0,
        'aria-label': this.label,
        name: this.nameProp
      }, this.qAttrs), {}, {
        id: this.targetUid,
        type: this.type,
        maxlength: this.maxlength,
        disabled: this.disable === true,
        readonly: this.readonly === true
      });

      if (this.autogrow === true) {
        attrs.rows = 1;
      }

      return attrs;
    }
  },
  methods: {
    focus: function focus() {
      var _this = this;

      addFocusFn(function () {
        var el = document.activeElement;

        if (_this.$refs.input !== void 0 && _this.$refs.input !== el && (el === null || el.id !== _this.targetUid)) {
          _this.$refs.input.focus();
        }
      });
    },
    select: function select() {
      this.$refs.input !== void 0 && this.$refs.input.select();
    },
    getNativeElement: function getNativeElement() {
      return this.$refs.input;
    },
    __onPaste: function __onPaste(e) {
      if (this.hasMask === true && this.reverseFillMask !== true) {
        var inp = e.target;

        this.__moveCursorForPaste(inp, inp.selectionStart, inp.selectionEnd);
      }

      this.$emit('paste', e);
    },
    __onInput: function __onInput(e) {
      if (!e || !e.target || e.target.composing === true) {
        return;
      }

      if (this.type === 'file') {
        this.$emit('input', e.target.files);
        return;
      }

      var val = e.target.value;

      if (this.hasMask === true) {
        this.__updateMaskValue(val, false, e.inputType);
      } else {
        this.__emitValue(val);

        if (this.isTypeText === true && e.target === document.activeElement) {
          var _e$target = e.target,
              selectionStart = _e$target.selectionStart,
              selectionEnd = _e$target.selectionEnd;

          if (selectionStart !== void 0 && selectionEnd !== void 0) {
            this.$nextTick(function () {
              if (e.target === document.activeElement && val.indexOf(e.target.value) === 0) {
                e.target.setSelectionRange(selectionStart, selectionEnd);
              }
            });
          }
        }
      } // we need to trigger it immediately too,
      // to avoid "flickering"


      this.autogrow === true && this.__adjustHeight();
    },
    __emitValue: function __emitValue(val, stopWatcher) {
      var _this2 = this;

      this.emitValueFn = function () {
        if (_this2.type !== 'number' && _this2.hasOwnProperty('tempValue') === true) {
          delete _this2.tempValue;
        }

        if (_this2.value !== val && _this2.emitCachedValue !== val) {
          _this2.emitCachedValue = val;
          stopWatcher === true && (_this2.stopValueWatcher = true);

          _this2.$emit('input', val);

          _this2.$nextTick(function () {
            _this2.emitCachedValue === val && (_this2.emitCachedValue = NaN);
          });
        }

        _this2.emitValueFn = void 0;
      };

      if (this.type === 'number') {
        this.typedNumber = true;
        this.tempValue = val;
      }

      if (this.debounce !== void 0) {
        clearTimeout(this.emitTimer);
        this.tempValue = val;
        this.emitTimer = setTimeout(this.emitValueFn, this.debounce);
      } else {
        this.emitValueFn();
      }
    },
    // textarea only
    __adjustHeight: function __adjustHeight() {
      var inp = this.$refs.input;

      if (inp !== void 0) {
        var parentStyle = inp.parentNode.style; // reset height of textarea to a small size to detect the real height
        // but keep the total control size the same

        parentStyle.marginBottom = inp.scrollHeight - 1 + 'px';
        inp.style.height = '1px';
        inp.style.height = inp.scrollHeight + 'px';
        parentStyle.marginBottom = '';
      }
    },
    __onChange: function __onChange(e) {
      this.__onComposition(e);

      clearTimeout(this.emitTimer);
      this.emitValueFn !== void 0 && this.emitValueFn();
      this.$emit('change', e);
    },
    __onFinishEditing: function __onFinishEditing(e) {
      var _this3 = this;

      e !== void 0 && stop(e);
      clearTimeout(this.emitTimer);
      this.emitValueFn !== void 0 && this.emitValueFn();
      this.typedNumber = false;
      this.stopValueWatcher = false;
      delete this.tempValue; // we need to use setTimeout instead of this.$nextTick
      // to avoid a bug where focusout is not emitted for type date/time/week/...

      this.type !== 'file' && setTimeout(function () {
        if (_this3.$refs.input !== void 0) {
          _this3.$refs.input.value = _this3.innerValue !== void 0 ? _this3.innerValue : '';
        }
      });
    },
    __getCurValue: function __getCurValue() {
      return this.hasOwnProperty('tempValue') === true ? this.tempValue : this.innerValue !== void 0 ? this.innerValue : '';
    },
    __getShadowControl: function __getShadowControl(h) {
      return h('div', {
        staticClass: 'q-field__native q-field__shadow absolute-bottom no-pointer-events' + (this.isTextarea === true ? '' : ' text-no-wrap')
      }, [h('span', {
        staticClass: 'invisible'
      }, this.__getCurValue()), h('span', this.shadowText)]);
    },
    __getControl: function __getControl(h) {
      return h(this.isTextarea === true ? 'textarea' : 'input', {
        ref: 'input',
        staticClass: 'q-field__native q-placeholder',
        style: this.inputStyle,
        class: this.inputClass,
        attrs: this.inputAttrs,
        on: this.onEvents,
        domProps: this.type !== 'file' ? {
          value: this.__getCurValue()
        } : this.formDomProps
      });
    }
  },
  created: function created() {
    this.emitCachedValue = NaN;
  },
  mounted: function mounted() {
    // textarea only
    this.autogrow === true && this.__adjustHeight();
  },
  beforeDestroy: function beforeDestroy() {
    this.__onFinishEditing();
  }
});